module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Vuks er feil.e85fc804.mp3";